import axios from "axios";
import createCookie from "@/app/core/CookieCore";
import config from '@/app/config';
import { createLocalStorage } from '@/app/utils/LocalStorage';

const cookie = createCookie();
const storage = createLocalStorage(config);

function createAxios(config) {
  const options = {
    baseURL: config.API_URL,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      Accept: "application/json",
      // 'Content-Type': 'application/json'
    },
  };

  const instance = axios.create(options);

  instance.interceptors.request.use(
    (request) => {
      if (cookie.getCookie("api_token")) {
        request.headers.Authorization = "Bearer " + cookie.getCookie("api_token");
      }

      const loja = storage.get('loja');
      if (loja) {
        request.headers['x-loja-id'] = loja.id;
      }

      return request;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const response_error = {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data,
      };

      return Promise.reject(response_error);
    }
  );

  return instance;
}

export default createAxios;
